<div class="content vat-list">
  <div class="content-body">
    <app-detail-header
      *ngIf="
        (moduleId$ | async) !== moduleEnum.BridgingVAT &&
        (moduleId$ | async) !== moduleEnum.SubmitVat
      "
      (triggerDataFromHeader)="getDataFromHeader($event)"
      [listParameters]="listParameters"
    >
    </app-detail-header>
    <div class="mat-table-wrapper">
      <table
        mat-table
        #table
        [dataSource]="dataSource"
        aria-describedby="Vat-Return"
      >
        <ng-container matColumnDef="boxNo">
          <th mat-header-cell *matHeaderCellDef class="w-50"><div class="white-space-nowrap">Box No.</div></th>
          <td mat-cell *matCellDef="let element"><div class="white-space-nowrap">{{ element.boxNo }}</div></td>
        </ng-container>
        <ng-container matColumnDef="vatDesc">
          <th mat-header-cell *matHeaderCellDef>VAT Description</th>
          <td mat-cell *matCellDef="let element">{{ element.vatDesc }}</td>
        </ng-container>
        <ng-container matColumnDef="vatAmount">
          <th mat-header-cell *matHeaderCellDef class="text-align-right w-100">
            Amount
          </th>
          <td mat-cell *matCellDef="let element" class="text-align-right">
            <span *ngIf="element.boxNo !== 'Box 5'">£ {{element.vatAmount | numberPipe }}</span>
            <span *ngIf="element.boxNo == 'Box 5'" [ngClass]="isPositiveValue ? 'status-active' : 'status-archived'">£ {{ displayvalue() | numberPipe }}</span>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div *ngIf="noDataFound" class="text-align-center mt-1 fw-bold">
        No Data Found
      </div>
    </div>
    <div class="review-box">
      <span>Amount you {{ isPositiveValue ? 'claim' : 'owe' }} in VAT £{{ displayvalue() | numberPipe}}</span>
    </div>
  </div>
</div>
